



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { client } from '@/store';
import { capitalize } from '../utils';
import { IUser, Maybe } from '../models';

const ComponentMap: Record<string, () => unknown> = {
  file: () => import(`@/views/File/FilePreview.vue`),
} as const;

@Component
export default class EntitySelect<T extends { id: number }> extends Vue {
  @Prop(String) readonly label: string;
  @Prop() readonly value: T[];
  @Prop({ default: true }) readonly override: any;
  @Prop({ default: () => [] }) readonly outerItems: IUser[];
  @Prop({ default: false }) readonly multiple: boolean;
  @Prop({ default: false }) readonly large: boolean;
  @Prop({ default: 'name' }) readonly itemText: (a1: T) => string | string;
  @Prop({ default: () => ({}) }) readonly change: any;
  @Prop() readonly getUrl: string;
  @Prop({ default: () => ({}) }) readonly preDefinedValues: any;
  @Prop(String) readonly type: string;
  modal = false;
  items: T[] = [];
  itemsOverride: T[] = [];
  searchString = '';
  multiId: Maybe<number> = null;

  openModalMulti(id: number) {
    this.multiId = id;
    this.modal = true;
  }
  mounted() {
    if (this.override) {
      client.get(`${this.fetchUrl}`).then(({ data }) => {
        this.itemsOverride = data.data ? data.data : data;
      });
    }
  }
  get item() {
    const override = this.itemsOverride || [];
    // @ts-ignore
    return [...override, ...this.items].find(({ id }) => id === this.value);
  }
  get component() {
    if (this.type === 'file' && this.multiId) return ComponentMap[this.type];
    const path = this.type.replace(/_\w/, (match) => {
      return match[1].toUpperCase();
    });
    return () =>
      import(`@/views/${capitalize(path)}/${capitalize(path)}Detail.vue`);
  }
  get fetchUrl() {
    return this.getUrl
      ? this.getUrl.match(/undefined/)
        ? this.type
        : this.getUrl
      : `${this.type}/all`;
  }
  removeItem(idx: number) {
    const values = this.value.filter((item) => {
      if (typeof item === 'object') {
        return item.id !== idx;
      } else {
        return item !== idx;
      }
    });
    this.change(values.flatMap((item) => item.id || item));
  }
  onChange({ entity: item }: { entity: T }) {
    this.multiId = null;
    this.modal = false;
    const index = this.itemsOverride.findIndex(({ id }) => {
      return id === item.id;
    });
    if (index > -1) Vue.set(this.itemsOverride, index, item);
    if (!this.multiple) {
      this.change(item.id);
    }
    if (this.multiple) {
      this.change([...this.value.map((item) => item.id || item)]);
    }
  }
  // @ts-ignore
  onCreate({ entity, redirect }) {
    if (redirect) {
      this.multiId = null;
      this.modal = false;
    }
    this.itemsOverride.push(entity);

    if (this.multiple) {
      const rez = this.value ? this.value : [];
      this.change([
        ...rez.map((item) =>
          typeof item === 'object' && item.hasOwnProperty('id')
            ? item.id
            : item,
        ),
        entity.id,
      ]);
    } else {
      this.change(entity.id);
    }
  }
  onClose() {
    this.multiId = null;
    this.modal = false;
  }
  @Watch('searchString')
  findEntity(name: string = '') {
    if (!name || name.length < 2) return;
    client
      .get(`/${this.type}/find`, { params: { name } })
      .then(({ data }) => (this.itemsOverride = data));
  }
  @Watch('getUrl')
  getItems(name: string = '') {
    client.get(`${this.fetchUrl}`).then(({ data }) => {
      this.itemsOverride = data.data ? data.data : data;
    });
  }
}
